import { FormValidators, VALIDATION_MESSAGES } from '../../hooks/useForm';
import { validateLettersSpacesAndNumbers } from '../../utils/validationUtils';

const { NOT_NAME, ONLY_LETTERS_SPACES_AND_NUMBERS, NOT_PRICE, NOT_USAGE_LIMIT } = VALIDATION_MESSAGES;

export interface CouponForm {
  name: string;
  price: number | undefined;
  usageLimit: number | undefined;
}

export const COUPON_FORM_VALIDATORS: FormValidators<CouponForm> = {
  name: (coupon) => {
    if (!coupon.name?.length) return NOT_NAME;
    if (!validateLettersSpacesAndNumbers(coupon.name)) return ONLY_LETTERS_SPACES_AND_NUMBERS;
  },
  price: ({ price }) => {
    // Same rule as the backend (CreateCouponDto / UpdateCouponDto: `@IsNumber() @Min(0)`): 0 is a free coupon.
    if (price === undefined || !Number.isFinite(price) || price < 0) return NOT_PRICE;
  },
  usageLimit: (coupon) => {
    if (!coupon.usageLimit) return NOT_USAGE_LIMIT;
  },
};
